import { useStore } from '@nanostores/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { EdgeFunctionsManager } from '~/components/ui/shadcn/components/supabase-manager/EdgeFunctions.client';
import { NoDatabaseScreen } from '~/components/ui/shadcn/components/supabase-manager/NoDatabaseScreen';
import { supabaseStore } from '~/lib/stores/supabase';

const queryClient = new QueryClient();

export const EdgeFunctions = () => {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);
  const project = useStore(supabaseStore.supabaseProject);
  const projectId = project?.id;

  if (supabaseStatus !== 'CONFIGURED' || !projectId) {
    return (
      <NoDatabaseScreen
        icon="i-bolt:edge-functions"
        description="You need a database to view your server functions directly from your project settings."
      />
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <EdgeFunctionsManager />
    </QueryClientProvider>
  );
};
